import dayjs from "dayjs";

export const formatDateTime = (date?: dayjs.Dayjs, time?: dayjs.Dayjs) =>
  date && time
    ? dayjs(`${date.format("YYYY-MM-DD")} ${time.format("HH:mm")}:00`).toISOString()
    : null;

export const formatDate = (date?: dayjs.Dayjs, time?: dayjs.Dayjs, fallback?: string | null) =>
  date && time
    ? dayjs(formatDateTime(date, time)).format("YYYY-MM-DD HH:mm:ss")
    : (fallback ?? null);

export const formatDateThai = (date: Date): string => {
  const monthsThai = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];

  const day = date.getDate();
  const month = monthsThai[date.getMonth()];
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  return `${day} ${month} ${year}, ${hour}:${minute}`;
};
export const formatThaiDate = (d?: string) =>
  d
    ? `${new Date(d).getDate()} ${
        [
          "มกราคม",
          "กุมภาพันธ์",
          "มีนาคม",
          "เมษายน",
          "พฤษภาคม",
          "มิถุนายน",
          "กรกฎาคม",
          "สิงหาคม",
          "กันยายน",
          "ตุลาคม",
          "พฤศจิกายน",
          "ธันวาคม",
        ][new Date(d).getMonth()]
      } ${new Date(d).getFullYear() + 543}`
    : "";
